import {Alert, Button, Input, Modal, Table} from 'antd'
import {CloseOutlined} from '@ant-design/icons'
import Divider from 'antd/lib/divider'
import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
import { AccountBean, ItemResponseAccountBeanObject, ListPagination } from 'src/api/api'
import { StorageKey, storageReaderFactory, storageWriterFactory } from 'src/util/Storage'
import { withActionsMediaQuery } from 'src/util/Util'
import { ActionsProps } from '../ActionsProps'
import accountApi from './AccountApi'
import { Link } from 'react-router-dom'

const Column = Table.Column

const storageWriter = storageWriterFactory('account')
const storageReader = storageReaderFactory('account')

const AccountList: React.FC<ActionsProps> = ({ areActionsVertical }) => {

    const [error, setError] = useState()
    const [data, setData] = useState<AccountBean[]>([])
    const [pagination, setPagination] = useState<any>({
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: 1,
        pageSize: 10
    })
    const [searchQuery, setSearchQuery] = useState<number|string>('')
    const pageSizeRef = useRef(10)
    const remove = (record: AccountBean) => {
        Modal.confirm({
            title: `Delete ${record.username}?`,
            content: 'All related advertisers will be deleted too. Are you sure?',
            cancelText: 'NO',
            okText: 'Yes, I\'m sure',
            onOk: () => {
                accountApi.delete(record.id as number).then(() => {
                    let page = pagination.current
                    if (data.length == 1 && pagination.current > 1) {
                        page -= 1
                    }
                    loadData(page, searchQuery)
                }).catch(err => {
                    setError(err.error)
                })
            }
        })
    }

    const loadData = (page: number, searchValue?: number | string, pageSize?: number) => {
        const currentPageSize = pageSize !== undefined ? pageSize : pageSizeRef.current

        accountApi
            .list(currentPageSize, page, searchValue) // pass searchValue
            .then(listResponseAccountBean => {
                const array = listResponseAccountBean.data as Array<ItemResponseAccountBeanObject>
                const accountBeans: AccountBean[] = array.map(item => item.data as AccountBean)
                if (accountBeans.length === 0 && page > 1) {
                    loadData(page - 1, searchValue, currentPageSize) // keep searchValue and pageSize
                } else {
                    const newPagination = listResponseAccountBean.pagination as ListPagination
                    const searchParams: any = {
                        page: newPagination.currentPage
                    }

                    if (searchValue !== undefined && searchValue !== null && searchValue !== '') {
                        if (typeof searchValue === 'number') {
                            searchParams.id = searchValue
                        } else {
                            searchParams.name = searchValue
                        }
                    }
                    //storageWriter.write(StorageKey.SearchParams, searchParams)

                    setData(accountBeans)
                    setPagination((prev: any) => {
                        pageSizeRef.current = currentPageSize // Update ref
                        return {
                            ...prev,
                            total: newPagination.total,
                            current: newPagination.currentPage,
                            pageSize: currentPageSize
                        }
                    })
                }
            })
    }

    useEffect(() => {
        let searchParams = storageReader.read(StorageKey.SearchParams) || {}
        let page = searchParams.page || pagination.current
        const searchValue = searchParams.id !== undefined 
            ? searchParams.id 
            : searchParams.name !== undefined 
            ? searchParams.name 
            : undefined

    
        loadData(page, searchValue)
    }, [])
    
    const filterData = (searchValue: number | string) => {
        setSearchQuery(searchValue)
        loadData(1, searchValue) // reset to first page on search
    }

    const parseSearchValue = (value: string): number | string => {
        if (value.trim() === '') return ''
        return /^\d+$/.test(value) ? Number(value) : value
    }

    return (
        <div>
            {error ? <Alert message={error} type="error"/> : null}
            <div className='flex gap-[10px]'>
                <div className="c-l-search-buttons" style={{width:'268px'}}>
                    <Input
                        addonAfter={<CloseOutlined onClick={() => {
                            setSearchQuery('')
                            filterData('')
                        }} />}
                        placeholder="Search by id, name and email"
                        value={searchQuery}
                        onChange={e => {
                            const parsedValue = parseSearchValue(e.target.value)
                            setSearchQuery(parsedValue)
                            filterData(parsedValue)
                        }}
                    />
                </div>
            </div>            
            <Table
                rowKey={'id'}
                size={'middle'}
                pagination={{
                    ...pagination,
                    showSizeChanger: true,
                    onChange: (page: number, pageSize: number) => {
                        loadData(page, searchQuery, pageSize)
                    }
                }}
                dataSource={data}>
                <Column key="id" title="ID" dataIndex="id" />
                <Column key="username" title="Name" dataIndex="username" />
                <Column key="role" title="Role" dataIndex="role" />
                <Column align={'center'} key="action" title="Actions" render={(text: string, record: AccountBean) => (
                    <span>
                        <Link to={`/account/${record.id}/edit`}>
                            <Button htmlType="button">Edit</Button>
                        </Link>
                        <Divider className="actions-horisontable-divider" type={areActionsVertical ? 'horizontal' : 'vertical'} />
                        <Button
                            onClick={() => remove(record)}
                            type="primary"
                            danger
                            htmlType="button">
                            Delete
                        </Button>
                    </span>
                )} />
            </Table>
            <Link to={`/account/create`}>
                <Button htmlType="button" type="primary">Create new</Button>
            </Link>
        </div>
    )
}

export default withActionsMediaQuery('650px')(AccountList)
